import { hFetch } from './hFetch';

export const createPhoneNumber = async (areaCode: string) => {
  const payload = {
    phone_number: {
      area_code: areaCode,
    },
  };

  return await hFetch({ url: '/api/phone_numbers', method: 'POST', payload });
};
